import { Component, OnInit } from '@angular/core';
import { Subject, switchMap, combineLatest, map, startWith, tap } from 'rxjs';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { ISearchSchedulerItemRequest } from 'src/app/scheduler/models/scheduler';
import { ResourcePlanerService } from 'src/app/scheduler/services/resource-planer.service';
import { HolidayService } from 'src/app/setting/holiday/services/holiday.service';
import { RessourceService } from 'src/app/setting/services/ressource.service';
import { ISearchAbsenceGroupsRequest } from 'src/app/time-tracking/models/absence-group';
import { AssignmentStorageService } from '../../storage/assignment-storage.service';

@Component({
    selector: 'app-assignment-scheduler',
    templateUrl: './assignment-scheduler.component.html',
    styleUrls: ['./assignment-scheduler.component.css'],
    standalone: false
})
export class AssignmentTimeSchedulerComponent implements OnInit {

  constructor(
    private assignmentStore: AssignmentStorageService,
    private resourcePlanerService: ResourcePlanerService,
    private holidayService: HolidayService,
    private ressourceService: RessourceService
  ) { }

  isLoading = false;

  // List Requests 

  searchRequest: ISearchSchedulerItemRequest = {
    pageNumber : 0,
    pageSize: 999999,
    start: new Date(new Date().setUTCHours(0,0,0,0)),
    end: new Date(new Date().setUTCHours(23,59,59,999))
  }

  listHolidayRequest : IBaseSearchRequest = {
    pageNumber: 0,
    pageSize: 999999,
    advancedFilter: {
      logic: "and",
      filters: [
        {
          field: "start",
          operator: "gte",
          value: new Date(new Date().setUTCHours(0,0,0,0))
        },
        {
          field: "end",
          operator: "lte",
          value: new Date(new Date().setUTCHours(23,59,59,999))
        }
      ]
    }
  }

  listAbsenceGroupRequest : ISearchAbsenceGroupsRequest = {
    pageNumber: 0,
    pageSize: 999999,
    start: new Date(new Date().setUTCHours(0,0,0,0)),
    end: new Date(new Date().setUTCHours(23,59,59,999))
  }

  // Data Streams

  schedulerRessourcesSub$ = new Subject<boolean>();

  schedulerRessources$ = this.schedulerRessourcesSub$.pipe(
    switchMap(x => this.ressourceService.searchRessources({pageNumber: 1, pageSize: 999999, isNotHidden: true})),
    map(x => x.data)
  );

  holidaySub$ = new Subject<boolean>();

  holidays$ = this.holidaySub$.pipe(
    switchMap(x => this.holidayService.searchHolidays(this.listHolidayRequest)
    ),
    map(x => x.data),
    startWith([])
  )

  eventsSub$ = new Subject<boolean>();

  events$ = this.holidaySub$.pipe(
    switchMap(x => this.resourcePlanerService.listEvents(this.searchRequest)
    ),
    map(x => x.data),
    startWith([])
  )

  absenceGroupSub$ = new Subject<boolean>();

  // Same planning feed as the resource planner: every employee's absences, reduced to "absent"
  // (period and state only) outside the viewer's supervisor reach. The regular absence search
  // would only return the viewer's own and their subordinates' absences.
  absenceGroups$ = this.absenceGroupSub$.pipe(
      switchMap(x => {
        Promise.resolve().then(() => this.isLoading = true);
        return this.resourcePlanerService.listAbsences(this.listAbsenceGroupRequest);
      }),
      map(x => x.data),
      startWith([])
  )

  vm$ = combineLatest([
    this.absenceGroups$.pipe(tap(x => this.isLoading = false)),
    this.holidays$,
    this.events$,
    this.schedulerRessources$,
    this.assignmentStore.assignment$.pipe(
      tap(x => this.schedulerRessourcesSub$.next(true))
    )
  ]).pipe(
    map(([
      absenceGroups,
      holidays,
      events,
      schedulerRessources,
      assignment
    ]) => ({
      absenceGroups,
      holidays,
      events,
      schedulerRessources,
      assignment
    }))
  );

  ngOnInit(): void {

  }

  onReloadEvents(){
    
    this.listHolidayRequest.advancedFilter.filters[0].value = this.searchRequest.start;
    this.listHolidayRequest.advancedFilter.filters[1].value = this.searchRequest.end;

    this.listAbsenceGroupRequest.start = this.searchRequest.start;
    this.listAbsenceGroupRequest.end = this.searchRequest.end;
    
    this.eventsSub$.next(true); 
    this.holidaySub$.next(true); 
    this.absenceGroupSub$.next(true); 
  }

}
